<mat-form-field appearance="outline" color="primary" class="w-full" [subscriptSizing]="subscriptSizing">
  <mat-chip-grid [formControl]="select" #chipGrid [disabled]="isDisabled" [required]="required">
    <mat-chip-row class="mat-chipss" *ngFor="let item of dataSource" (removed)="remove(item)">
      {{ item }}
      <button matChipRemove>
        <mat-icon class="material-icons-outlined">cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      matInput
      [placeholder]="placeholder"
      i18n-placeholder
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      #chipInput
      [matAutocomplete]="auto"
      [spMatChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      [matTooltip]="chipInputTooltip"
      (keydown.escape)="removeAutoComp()"
      (keydown.enter)="addTabOnEnter($event)"
      [required]="required"
    />
  </mat-chip-grid>
  <mat-error *ngIf="chipGrid.errorState"> {{ requiredText }} </mat-error>
  <mat-autocomplete #auto="matAutocomplete" class="sp-dynamic-height-panel" (opened)="updatePanelHeight()" (optionSelected)="selected($event.option.value)">
    <mat-option *ngFor="let source of autoCompSource" [value]="source">
      <span [innerHTML]="source.name | highlightSearchText: tagToHighlight"></span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
